import generateCalendar from "antd/es/calendar/generateCalendar";
import type { Moment } from "moment";
import momentGenerateConfig from "rc-picker/lib/generate/moment";

const Calendar = generateCalendar<Moment>(momentGenerateConfig as any);

export default Calendar;
